import { useParams } from '@tanstack/react-router';
import { screenById } from '../screens/definitions';
import { ScreenPage } from '../screens/ScreenPage';
import { PinnedReports } from './PinnedReports';
import { NotFoundPage } from './NotFoundPage';

export function ScreenRoute({ section }: { section: string }) {
  const params = useParams({ strict: false }) as { tab?: string };
  const id = section === 'summary' || section === 'coverage' ? section : `${section}.${params.tab ?? ''}`;
  const screen = screenById(id);
  if (!screen) return <NotFoundPage />;
  return (
    <>
      <ScreenPage screen={screen} />
      {section === 'summary' ? <PinnedReports /> : null}
    </>
  );
}
